import Api from "../../apis/api";
import globalstorageapi from "../../global/GlobalStrorage";
export default {
    getuserbyid() {
        let currentuserid = globalstorageapi.getloginuserid();
        let apiurl = "user/?" + "id=" + currentuserid;
        //alert('dd'+apiurl);
        return Api.get(apiurl);
      },
    getprojectlistbyuserid() {

        let currentuserid = globalstorageapi.getloginuserid();
       
       let apiurl = "projectlist_byuserid/?user_id=" + currentuserid + "";
       
       // //alert(apiurl);
        return Api.get(apiurl);
    },
    getteamlist_byproject(projectid, userid) {

        let apiurl = "teamlist_byproject/?project=" + projectid + "&user=" + userid + "";
//alert(apiurl);
        return Api.get(apiurl);
    },
    project_user_mapping(projectid, mapuserid, createdby) {

        let apiurl = "project_user_mapping/?project=" + projectid + "&user=" + mapuserid + "&createdby=" + createdby + "";

        return Api.get(apiurl);
    },
    project_user_mapping_delete(projectid, mapuserid, createdby) {

        let apiurl = "project_user_mapping/?isdisable=1&project=" + projectid + "&user=" + mapuserid + "&createdby=" + createdby + "";

        return Api.get(apiurl);
    },
    project_user_mapping_remap(projectid, mapuserid, createdby) {

        let apiurl = "project_user_mapping/?isdisable=0&project=" + projectid + "&user=" + mapuserid + "&createdby=" + createdby + "";

        return Api.get(apiurl);
    },
    createNewProject(projectname) {
        let apiurl = "save_project/?name=" + projectname + "&ownerid=" + globalstorageapi.getloginuserid() + "";
       // //alert(apiurl);
        return Api.get(apiurl);
    },
    api_Change_project_completeToWIP(varprojectid){
       // alert(this.getprojectid());
        let apiurl = "save_project/?id="+varprojectid+"&status=Work In Progress" ;
        alert(apiurl);
        return Api.get(apiurl);
      }
}